export default {"src":"/_next/static/media/deposit_details_info_icon.b7405f2c.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};